export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: "Aydın İnşaat İstanbul'da hangi hizmetleri sunuyor?",
    answer:
      "Biz Aydın Grup Yapı; Aydın İnşaat hizmetleri kapsamında İstanbul genelinde kentsel dönüşüm, kat karşılığı inşaat, konut projeleri, bina yenileme ve anahtar teslim uygulamalar sunar. Her talep, yapının ve arsanın mevcut durumuna göre ayrı olarak değerlendirilir.",
  },
  {
    question: "İstanbul'un hangi ilçelerinde hizmet veriyorsunuz?",
    answer:
      "Güngören merkezli ekibimizle İstanbul'un Avrupa ve Anadolu Yakası'ndaki 39 ilçesinden gelen proje taleplerini değerlendiriyoruz. Hizmet alanımız belirli ilçelerle sınırlı değildir; uygun projeler için yerinde ön inceleme planlanır.",
  },
  {
    question: "Kentsel dönüşüm süreci nasıl başlar?",
    answer:
      "İlk adım mevcut yapının, tapu ve arsa bilgilerinin ve kat maliklerinin beklentilerinin değerlendirilmesidir. Ardından uygulanabilir proje modeli, yaklaşık süreç, resmi işlemler ve tarafların sorumlulukları netleştirilir.",
  },
  {
    question: "Kat karşılığı inşaat için nasıl teklif alınır?",
    answer:
      "Arsanın konumu, ada-parsel bilgisi, mevcut yapı durumu ve malik beklentileri paylaşılır. Ön değerlendirmeden sonra imar koşulları ve projenin uygulanabilirliği incelenerek görüşme ve teklif süreci planlanır.",
  },
  {
    question: "Bina yenileme ile kentsel dönüşüm arasındaki fark nedir?",
    answer:
      "Bina yenileme; yapının kapsamlı tadilat veya yeniden yapım ihtiyacını ifade edebilir. Kentsel dönüşüm ise riskli yapı tespiti, tahliye, yıkım, proje ve ruhsat gibi mevzuata bağlı adımlar içerebilir. Doğru yöntem yapının durumuna göre belirlenir.",
  },
  {
    question: "Anahtar teslim inşaat hizmetine neler dahildir?",
    answer:
      "Kapsama göre mimari ve teknik planlama, ruhsat koordinasyonu, kaba ve ince inşaat, mekanik-elektrik uygulamalar, malzeme tedariği, saha yönetimi ve teslim süreçleri birlikte yürütülebilir. Kesin kapsam sözleşme öncesinde açıkça belirlenir.",
  },
  {
    question: "Projelerde deprem güvenliği nasıl ele alınıyor?",
    answer:
      "Yeni yapı projeleri yürürlükteki mevzuat, zemin ve proje verileri ile yetkili mühendislik disiplinlerinin hesapları doğrultusunda planlanır. Malzeme, uygulama ve saha kontrolleri proje gereklilikleriyle birlikte takip edilir.",
  },
  {
    question: "İlk proje görüşmesi için hangi bilgiler gerekir?",
    answer:
      "Proje adresi, varsa ada-parsel bilgileri, mevcut yapı fotoğrafları, tapu veya arsa bilgileri ve beklentilerin kısa bir özeti ilk değerlendirme için yeterlidir. Gerektiğinde yerinde inceleme planlanır.",
  },
  {
    question: "Bir inşaat projesi ne kadar sürede tamamlanır?",
    answer:
      "Süre; projenin büyüklüğüne, ruhsat ve resmi onaylara, mevcut yapının durumuna, teknik kapsamına ve saha koşullarına göre değişir. Ön inceleme sonrasında gerçekçi bir iş programı hazırlanır ve süreç bu program üzerinden takip edilir.",
  },
  {
    question: "Biz Aydın Grup'un tamamlanan projelerini nerede görebilirim?",
    answer:
      "Aydın Park Evleri, Kartal, Güngören, Tekirdağ, Zeytinburnu ve Bahçelievler'deki proje sayfalarımızda uygulama görsellerini ve proje yaklaşımını inceleyebilirsiniz. Güngören Akıncılar kentsel dönüşüm çalışması da ayrı proje sayfasında yer alır.",
  },
];
